import React, { useState, useEffect, useReducer } from "react";
import { TextField, Card, Hidden, CardContent, Button, Box, Typography, Grid, MenuItem } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { VERSION } from "../../constants/version";
import { isBrowser, isMobile, osName, osVersion, browserVersion, browserName, mobileModel } from "react-device-detect";
import { useAuth } from "../../context/auth-context";
import { useLocalStorage } from "../../utils/hooks";
import { useNotification } from "../../context/notification-context";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { FullPageSpinner } from "../../components/lib";
import ErrorLoginPage from "../ErrorLogin";
import { useGlobalState } from "../../context/global-state-context";
import { DEBUG_FLAG } from "../../constants/debug";
import { SupportButton } from "../SupportComponent/Support";
import { useTranslation } from "react-i18next";
import { useDeviceName } from "../../context/devicename-context";
import { useZulassung } from "../../context/zulassungs-context";
import ectoollogo from '../../assets/images/ectool_Logo_2019.png';

const initialState = {
  isLoading: true,
  preLoginUser: null,
  sso: null,
};
function reducer(state, action) {
  switch (action.type) {
    case "startLoading":
      return { isLoading: true, preLoginUser: null, sso: null };
    case "loadingSuccess":
      return { isLoading: false, preLoginUser: action.user, sso: action.sso };
    case "loadingError":
      return { isLoading: false, preLoginUser: null, sso: null };
    default:
      throw new Error();
  }
}

const Login_SSO_Debug = false;
const Is_SSO_Callback =
  window &&
  window.location &&
  window.location.pathname &&
  window.location.pathname.toLowerCase() === "/sso" &&
  !window.location?.search.startsWith("?domain=");

function LoginPassword() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showAdmincode, setShowAdmincode] = useState(false);
  const [username, setUsername] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [deviceId] = useLocalStorage(DEBUG_FLAG() ? LOCAL_STORAGE_KEY.deviceIdLocal : LOCAL_STORAGE_KEY.deviceId);
  const { login, loginAdmincode } = useAuth();
  const notificationToken = useNotification();
  const [forgotPassword, setForgotPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [admincodeError, setAdmincodeError] = useState("");
  const [admincode, setAdmincode] = useState("");

  const [isSending, setIsSending] = useState(false);
  const [isRedirecting, setisRedirecting] = useState(false);

  const [state, dispatch] = useReducer(reducer, initialState);
  const [, setGlobalState] = useGlobalState();
  const { deviceName } = useDeviceName();
  const [deviceVersion] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const { updatePrograms } = useZulassung();

  // const [SSO_Storage,setSSO_Storage] = useSessionStorage('SSO');
  // -.- man bekommt erst mit dem zweiten Rendern den zuletzt gespeicherten Wert -.-
  const SSO_Storage = (window && window.sessionStorage && window.sessionStorage.getItem("SSO")) || "";
  const setSSO_Storage = (val) => window && window.sessionStorage && window.sessionStorage.setItem("SSO", val);
  var SSO = !!SSO_Storage ? JSON.parse(SSO_Storage) : {};

  useEffect(() => {
    updatePrograms([]);
  }, []);

  useEffect(() => {
    if (Is_SSO_Callback) {
      dispatch({ type: "loadingSuccess", user: null, sso: "callback" });
      return;
    }

    dispatch({ type: "startLoading" });
    if (!username) return; // .. State-Change >> Render mit leeren username .. warum hier?

    // .. das funktioniert hier nicht -.- >> aufgenommen in UnauthenticatedApp
    // if (username && window && window.location && window.location.pathname && window.location.pathname.toLowerCase() === '/sso' && window.location?.search.startsWith('?domain=') && window.location.search !== '?domain='+username) {
    // dispatch({type: 'loadingError'});
    // setUsername('');
    // return;
    // }

    //setUserIsLoading(true);
    setGlobalState("firstLogin", false);
    const payload = {
      username: username,
      deviceId: deviceId,
    };
    if (isBrowser) payload.browser = browserName + " " + browserVersion;

    axios
      .post(API_BASE_URL + "login/user", payload)
      .then(function (response) {
        dispatch({ type: "loadingSuccess", user: response.data.user, sso: response.data.sso });
        //setUserIsLoading(false);
        //setPreLoginUser(response.data.user);
      })
      .catch(function (err) {
        dispatch({ type: "loadingError" });
        if (err.response) {
          setUsername("");
          // localStorage.setItem(LOCAL_STORAGE_KEY.username, "");
          // window.location.reload();
          console.log(err.response.status);
          console.log(err.response.data.message);
        } else {
          console.log(err);
        }
      });
  }, [username, deviceId, setGlobalState]);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleClickShowAdmincode = () => {
    setShowAdmincode(!showAdmincode);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleAdmincodeSubmitClick = (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    var payload = {};
    if (isMobile) {
      payload = {
        username: username,
        admincode: admincode,
        deviceId: deviceId,
        notifToken: notificationToken,
        device: mobileModel,
        deviceName: mobileModel,
        os: osName,
        osBez: mobileModel + " " + osName + " " + osVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }
    if (isBrowser) {
      payload = {
        username: username,
        admincode: admincode,
        deviceId: deviceId,
        deviceName: deviceName,
        notifToken: notificationToken,
        browser: browserName + " " + browserVersion,
        os: osName,
        osBez: osName + " " + osVersion + " " + browserName + " " + browserVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }
    loginAdmincode(payload)
      .then((data) => {
        setIsSending(false);
        if (data) {
        }
      })
      .catch((error) => {
        setIsSending(false);
        setAdmincodeError(error.message);
      });
  };
  const updateAdmincode = (e) => {
    e.preventDefault();
    setAdmincode(e.target.value);
  };

  const handlePasswordSubmitClick = (e) => {
    e.preventDefault();
    if (isSending) return;
    setIsSending(true);
    var payload = {};
    if (isMobile) {
      payload = {
        username: username,
        password: password,
        deviceId: deviceId,
        notifToken: notificationToken,
        device: mobileModel,
        deviceName: mobileModel,
        os: osName,
        osBez: mobileModel + " " + osName + " " + osVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }
    if (isBrowser) {
      payload = {
        username: username,
        password: password,
        deviceId: deviceId,
        deviceName: deviceName,
        notifToken: notificationToken,
        browser: browserName + " " + browserVersion,
        os: osName,
        osBez: osName + " " + osVersion + " " + browserName + " " + browserVersion,
        clientVersion: deviceVersion,
        clientBuild: VERSION,
      };
    }

    login(payload)
      .then((data) => {
        if (data) {
          setPasswordError(data.message);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setPasswordError(error.message);
      });
  };

  const SSO_DoLogin = (sso_data) => {
    if (isSending) return;
    setIsSending(true);

    // Kern-Daten...
    var payload = {
      username: username,
      password: JSON.stringify(sso_data.CallbackParameter),
    };
    if (!payload.username.toLowerCase().startsWith("sso:") && !payload.username.includes("@"))
      payload.username = "sso:" + sso_data.Domain;
    if (!payload.username.toLowerCase().startsWith("sso:")) payload.username = "sso:" + payload.username;

    // .. das könnte doch zentral im AuthProvider nachgepflegt werden

    // Grundsätzlich egal, ob Mobil / Browser
    payload.deviceId = deviceId;
    payload.clientVersion = deviceVersion;
    payload.clientBuild = VERSION;
    payload.os = osName;
    payload.notifToken = notificationToken;

    // spezifische Angaben
    if (isMobile) {
      payload.device = mobileModel;
      payload.deviceName = mobileModel;
      payload.osBez = mobileModel + " " + osName + " " + osVersion;
    }

    if (isBrowser) {
      payload.deviceName = deviceName;
      payload.browser = browserName + " " + browserVersion;
      payload.osBez = osName + " " + osVersion + " " + browserName + " " + browserVersion;
    }

    login(payload)
      .then((data) => {
        if (data) {
          setPasswordError(data.message);
        }
      })
      .catch((error) => {
        setIsSending(false);
        setPasswordError(error.message);
      });
  };

  const SSO_DoAuth = (sso_data) => {
    // Aktuelle URL ersetzen (> keine Historie)
    // .. alle Varianten scheinen die Location zu ersetzen? .. das ist aber abhängig vom Browser
    let AuthURL_Replace = false;

    // Bei SSO-Direkteinstieg ist Replace fast schon Pflicht um Dauerschleife per Zurück zu vermeiden
    if (sso_data.DoAuth) AuthURL_Replace = true;

    sso_data.DoAuth = false;
    sso_data.ecAuthRedirected = new Date().toISOString();
    setSSO_Storage(JSON.stringify(sso_data));
    setisRedirecting(true);
    setPassword("");
    setPasswordError("");
    if (Login_SSO_Debug)
      console.log(
        "LoginUserPW> DoAuth .. SSO.state:" + sso_data?.state,
        " SSO.CallbackState:" + sso_data?.CallbackState,
        " SSO.nonce:" + sso_data?.nonce,
        " SSO-AuthURL:" + sso_data.AuthURL
      );

    if (AuthURL_Replace) {
      window.location.replace(sso_data.AuthURL);
    } else {
      // .. solange wir target = _self verwenden, können wir die URL auch so umbiegen
      // ggf. wegen .rel - Eigenschaften interessant
      window.location.href = sso_data.AuthURL;
      // var link = document.createElement('a');
      // link.href = sso_data.AuthURL;
      // link.rel = 'nofollow noopener noreferrer'
      // link.target = '_self';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    }
  };

  if (state.isLoading || !username) return <FullPageSpinner />;

  if (!state.preLoginUser && !state.sso) return <ErrorLoginPage />;

  // SSO-Callback .. dann Parameter merken und ursprüngliche URL aufrufen
  if (Is_SSO_Callback) {
    const sso_auth_params = new URLSearchParams(window.location.search);
    const sso_callback_state = sso_auth_params.get("state");
    if (Login_SSO_Debug)
      console.log(
        "LoginUserPW > SSO-Callback .. isRedirecting:",
        isRedirecting,
        " CallbackState:" + sso_callback_state,
        " SSO.state:" + SSO?.state,
        " SSO.CallbackState:" + SSO?.CallbackState,
        " SSO.nonce:" + SSO?.nonce
      );

    // -.- SSO_Storage? .. man bekommt beim nächsten Render nicht den Wert den man aktuell setzt >> Dauerschleife
    if (!isRedirecting) {
      var redirect_uri = "";
      var SSO_Callback_OK = false;
      if (SSO && sso_callback_state && SSO.state === sso_callback_state) {
        redirect_uri = SSO.LocationPreAuth;
        SSO.CallbackState = sso_callback_state;
        SSO.CallbackParameter = Object.fromEntries(sso_auth_params);
        SSO.CallbackParameter.redirect_uri = SSO.redirect_uri;
        SSO.CallbackParameter.nonce = SSO.nonce;
        if (!SSO.CallbackParameter.iss) SSO.CallbackParameter.iss = SSO.issuer;
        if (window?.document?.referrer) SSO.CallbackParameter.referrer = window?.document?.referrer;
        SSO.CallbackParameter.ecIssuer = SSO.issuer;
        SSO.CallbackParameter.ecLocationPreAuth = SSO.LocationPreAuth;
        SSO.CallbackParameter.ecAuthRedirected = SSO.ecAuthRedirected;
        SSO.CallbackParameter.ecAuthCreated = SSO.ecAuthCreated;
        SSO.CallbackParameter.ecCallbackRcvd = new Date().toISOString();
        if (Login_SSO_Debug)
          console.log("LoginUserPW > SSO-Callback .. >> Parameter saved..", SSO.CallbackParameter, " ..SSO: ", SSO);
        setSSO_Storage(JSON.stringify(SSO));
        SSO_Callback_OK = true;
      }

      if (!redirect_uri || !SSO_Callback_OK) {
        if (Login_SSO_Debug)
          console.log(
            "LoginUserPW > SSO-Callback >> NoRedirectURI .. InvalidData (State?) > Parameter not saved.. State Invalid -SSO_State:",
            SSO.state,
            " -Callback_State:",
            sso_callback_state
          );
        var redirect_uri = window.location.origin;
        if (window.location.hash) redirect_uri += "/" + window.location.hash;
        setSSO_Storage("");
      }
      setisRedirecting(true);
      window.location.replace(redirect_uri);
    }

    return (
      <Box p={2}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">SingleSignOn</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">SSO-Provider-Login recieved ...</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isSending && <FullPageSpinner />}
      </Box>
    );
  }

  // Der Reset müsste bereits vorher stattfinden! .. doppelt hält besser
  if (!state.sso && SSO_Storage) {
    if (Login_SSO_Debug) console.log("LoginUserPW> kein state.sso >> reset SSO_Storage");
    setSSO_Storage("");
    SSO = null;
  }

  // Grs. Funktionen, falls SSO möglich..
  if (state.sso) {
    // if (Login_SSO_Debug) console.log('LoginUserPW> SSO (CheckStart) state:',{...state.sso},' Storage:',{...SSO}, ' Location:'+window.location);

    if (!SSO || SSO?.Domain !== state.sso.Domain || SSO?.issuer !== state.sso.issuer) {
      if (Login_SSO_Debug)
        console.log("LoginUserPW> SSO (Domain Invalid>Changed): ", { ...SSO }, " ..state.sso:" + state.sso);
      SSO = {};
      SSO.Domain = state.sso.Domain;
      SSO.issuer = state.sso.issuer;
    }

    if (!isSending && SSO.state && SSO.CallbackParameter && SSO.state === SSO.CallbackState) {
      if (Login_SSO_Debug) console.log("LoginUserPW> SSO >>> DoLogin", { ...SSO });
      // extra Funktion? .. wir missbrauchen eh schon das Password-Feld für Fehler
      SSO_DoLogin(SSO);
    }

    if (SSO.CallbackParameter) {
      SSO.CallbackParameter = null;
      SSO.state = null;
    }

    let LocationPreAuth = window.location.href;
    // Direkteinstieg... dann nach Auth nicht erneut auf Direkt-Einstieg
    if (window.location.pathname.toLowerCase() === "/sso") {
      LocationPreAuth = window.location.origin;
      // Hash behalten für Direkt-Einstieg
      if (window.location.hash) LocationPreAuth += "/" + window.location.hash;
    }

    if (
      !SSO.state ||
      !SSO.AuthURL ||
      SSO.LocationPreAuth !== LocationPreAuth ||
      (SSO.CallbackState && SSO.CallbackState !== SSO.state) ||
      SSO.nonce !== state.sso.nonce
    ) {
      if (Login_SSO_Debug) console.log("LoginUserPW> SSO (Check) >> Generate (new) AuthURL");

      // state für hier (Client) .. nonce später (Provider>Server)
      SSO.state = crypto.randomUUID() + ":" + SSO.Domain;
      SSO.nonce = state.sso.nonce;
      SSO.redirect_uri = window.location.origin + "/sso";
      SSO.ecAuthCreated = new Date().toISOString();

      SSO.LocationPreAuth = LocationPreAuth;
      if (SSO.LocationPreAuth === SSO.redirect_uri) SSO.LocationPreAuth = window.location.origin;
      // Direkter SSO-Einstieg .. SSO-Auth direkt ausführen
      if (window.location.pathname.toLowerCase() === "/sso" && window.location.search === "?domain=" + SSO.Domain)
        SSO.DoAuth = true;

      var SSO_AuthURL_Pars = new URLSearchParams();
      SSO_AuthURL_Pars.append("state", SSO.state);
      SSO_AuthURL_Pars.append("redirect_uri", SSO.redirect_uri);
      SSO_AuthURL_Pars = SSO_AuthURL_Pars.toString();

      SSO.AuthURL = state.sso.AuthURL + "&" + SSO_AuthURL_Pars;
      SSO.CallbackState = "";
    }

    if (Login_SSO_Debug) console.log("LoginUserPW> SSO (CheckEnde):", { ...SSO });

    var sso_storage_neu = JSON.stringify(SSO);
    if (sso_storage_neu !== SSO_Storage) {
      if (Login_SSO_Debug) console.log("LoginUserPW> SSO (Changed) .. old:", SSO_Storage, " ..new:", sso_storage_neu);
      setSSO_Storage(sso_storage_neu);
      if (SSO.DoAuth) SSO_DoAuth(SSO);
    }
  }

  // Kein Anwender .. nur SSO? .. dann separate Anzeige?
  if (state.sso && !state?.preLoginUser?.id) {
    var SSO_Login_Fehler = passwordError;
    if (Login_SSO_Debug) console.log("LoginUserPW> SSO .. Login-Fehler?", SSO_Login_Fehler);
    return (
      <Box p={2}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{"SingleSignOn - " + state.sso.Domain}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">
                          {t("Bitte melden Sie sich über Ihren SSO-Provider an.")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => SSO_DoAuth(SSO)}
                          disabled={isSending || isRedirecting}
                        >
                          {t("Zum SSO-Provider-Login")}
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        {isRedirecting && (
                          <Typography>{t("Sie werden zum SSO-Provider-Login weitergeleitet.")}</Typography>
                        )}
                        {Login_SSO_Debug && isSending && <Typography>{t("Login-Vorgang...")}</Typography>}
                        {SSO_Login_Fehler && <Typography color="error">{SSO_Login_Fehler}</Typography>}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Box p={2}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Button
                        type="button"
                        color="primary"
                        variant="outlined"
                        onClick={() => {
                          setUsername("");
                          setSSO_Storage("");
                        }}
                      >
                        {t("Benutzer wechseln")}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
                <Box p={2}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box p={1}>
                        <Typography variant="body1">{t("Benötigen Sie Hilfe?")}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <SupportButton callLocation="Passwort" />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isSending && <FullPageSpinner />}
      </Box>
    );
  }

  if (state.preLoginUser.startpassword === "J") {
    return (
      <Box p={2}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{t("Hallo") + " " + username}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">
                          {t("Um Ihren Account freizuschalten, geben Sie Ihren Einmalcode ein.")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          href="https://docs.ectool.de/app/verifizieren/#miteinmalcodebesttigen"
                          color="primary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("Wo finde ich meinen EinmalCode?")}
                        </Button>
                      </Grid>
                    </Grid>
                    <form>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            type={showAdmincode ? "text" : "password"}
                            fullWidth
                            error={admincodeError !== ""}
                            helperText={admincodeError}
                            label={t("Einmalcode")}
                            variant="outlined"
                            id="password"
                            placeholder="Einmalcode eingeben ..."
                            value={admincode}
                            onChange={(e) => updateAdmincode(e)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle admincode visibility"
                                    tabIndex={-1}
                                    onClick={handleClickShowAdmincode}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            onClick={handleAdmincodeSubmitClick}
                            fullWidth
                          >
                            {t("Jetzt freischalten")}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
                <Box p={2}>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Box p={1}>
                        <Typography variant="body1">{t("Sie sind nicht") + " " + username + "?"}</Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="button"
                        color="primary"
                        fullWidth
                        onClick={() => setUsername("")}
                        variant="outlined"
                      >
                        {t("Benutzer wechseln")}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isSending && <FullPageSpinner />}
      </Box>
    );
  }
  if (forgotPassword) {
    return (
      <Box p={2}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8} md={6}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h5">{t("Passwort vergessen")}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body1">
                          {t("Um Ihr Passwort zurückzusetzen, geben Sie bitte den Admin-Code ein.")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          href="https://docs.ectool.de/app/wo-finde-ich-den-admincode/#deradmincodestehtimverwendungszweckihrereletztengehaltsberweisung"
                          color="primary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("Wo finde ich meinen Admin-Code?")}
                        </Button>
                      </Grid>
                    </Grid>
                    <form>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            type={showAdmincode ? "text" : "password"}
                            label={t("Admin-Code")}
                            variant="outlined"
                            fullWidth
                            id="admincode"
                            placeholder="XXXXXXXX"
                            value={admincode}
                            onChange={(e) => updateAdmincode(e)}
                            error={admincodeError !== ""}
                            helperText={admincodeError}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    tabIndex={-1}
                                    onClick={handleClickShowAdmincode}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showAdmincode ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                        <Hidden smUp>
                          <Grid item xs={12}>
                            <Button
                              type="submit"
                              color="primary"
                              variant="contained"
                              fullWidth
                              onClick={handleAdmincodeSubmitClick}
                            >
                              {t("Zurücksetzen")}
                            </Button>
                          </Grid>
                        </Hidden>
                        <Grid item xs={12} sm={6}>
                          <Button key="cancel" color="primary" fullWidth onClick={() => setForgotPassword(false)}>
                            {t("Abbrechen")}
                          </Button>
                        </Grid>
                        <Hidden smDown>
                          <Grid item xs={6}>
                            <Button
                              type="submit"
                              color="primary"
                              variant="contained"
                              fullWidth
                              onClick={handleAdmincodeSubmitClick}
                            >
                              {t("Zurücksetzen")}
                            </Button>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {isSending && <FullPageSpinner />}
      </Box>
    );
  }

  return (
    <Box p={2}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <img src={ectoollogo} height="50" alt="ectool" loading="lazy" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h5">{t("Hallo") + " " + username}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">{t("Geben Sie Ihr Passwort ein um sich anzumelden")}</Typography>
                    </Grid>
                  </Grid>
                  <form>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          type={showPassword ? "text" : "password"}
                          fullWidth
                          error={passwordError !== ""}
                          helperText={t(passwordError)}
                          label={t("Passwort")}
                          variant="outlined"
                          id="password"
                          placeholder={t("Passwort eingeben ...")}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          InputProps={{
                            autoFocus: true,
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  tabIndex={-1}
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Hidden smUp>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            onClick={handlePasswordSubmitClick}
                            fullWidth
                          >
                            {t("Anmelden")}
                          </Button>
                        </Grid>
                      </Hidden>
                      <Grid item xs={12} sm={6}>
                        <Button key="forgotPassword" color="primary" onClick={() => setForgotPassword(true)}>
                          {t("Passwort vergessen?")}
                        </Button>
                      </Grid>
                      <Hidden smDown>
                        <Grid item xs={12} sm={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                            onClick={handlePasswordSubmitClick}
                            fullWidth
                          >
                            {t("Anmelden")}
                          </Button>
                        </Grid>
                      </Hidden>
                      {state.sso && (
                        <>
                          <Grid item xs={12}>
                            <Button
                              color="primary"
                              onClick={() => SSO_DoAuth(SSO)}
                              disabled={isSending || isRedirecting}
                            >
                              {t("Anmelden über (externen) SSO-Provider")}
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            {isRedirecting && (
                              <Typography>{t("Sie werden zum SSO-Provider-Login weitergeleitet.")}</Typography>
                            )}
                            {Login_SSO_Debug && isSending && <Typography>{t("Login-Vorgang...")}</Typography>}
                            {SSO_Login_Fehler && <Typography color="error">{SSO_Login_Fehler}</Typography>}
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </form>
                </CardContent>
              </Card>
              <Box p={2}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography variant="body1">{t("Sie sind nicht") + " " + username + "?"}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Button type="button" color="primary" fullWidth onClick={() => setUsername("")} variant="outlined">
                      {t("Benutzer wechseln")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
              <Box p={2}>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Box p={1}>
                      <Typography variant="body1">{t("Benötigen Sie Hilfe?")}</Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <SupportButton callLocation="Passwort" />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {(isSending || isRedirecting) && <FullPageSpinner />}
    </Box>
  );
}
export default LoginPassword;
